import { customerQuery } from "@common/api/customers"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useRouter } from "@tanstack/react-router"
import { PageContent } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { DetailsForm } from "./-components/details-form"

export const Route = createFileRoute("/_layout/customer_/$customerId/")({
  component: CustomerGeneral,
})

function CustomerGeneral(): React.ReactElement {
  const { customerId } = Route.useParams()
  const showToast = useCustomToast()
  const router = useRouter()
  const { data: customer } = useSuspenseQuery(
    customerQuery({ customer_id: customerId }),
  )

  return (
    <div className="min-w-0 flex-1 overflow-y-auto">
      <PageContent>
        <DetailsForm
          key={`${customer.id}-${customer.archived_at}`}
          customer={customer}
          onRestore={() => showToast("Restored", "Record restored.", "success")}
          onSave={(saved) => {
            showToast(
              "Saved",
              `${saved.name || "Customer"} updated.`,
              "success",
            )
            router.invalidate()
          }}
        />
      </PageContent>
    </div>
  )
}
